import { React } from 'Imports';
import { useBlocker } from 'react-router-dom';
import type { Location } from 'react-router-dom';

interface NavigationPromptProps {
  when: boolean;
  shouldBlock: (location: Location) => boolean;
}

/**
 * Mimics react-router v5 <Prompt>. Calls shouldBlock(location).
 * If shouldBlock returns true, navigation proceeds; otherwise it is blocked.
 */
export const NavigationPrompt: React.FC<NavigationPromptProps> = ({ when, shouldBlock }) => {
  useBlocker(({ currentLocation, nextLocation }) => {
    if (!when) return false;

    const allow = shouldBlock(nextLocation);
    return !allow; // useBlocker blocks when true is returned
  });

  return null;
};
